import { useLocation } from 'react-router-dom';
import { ZodSchema } from 'zod';

export function useLocationState<T>(schema: ZodSchema<T>): T {
    const location = useLocation();
    return schema.parse(location.state);
}
